import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';
import { Users } from 'react-feather';

function MutasiPinjaman() {

  //Roles
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataMutasi, setDataMutasi] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataMutasi = async (id) => {

    await baseAPI
      .get(`/v1/mutasipinjam/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.mutasipinjam;
        setDataMutasi(data)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  useEffect(() => {
    setIsLoading(true);
    // if (users.role === ANGGOTA) {
      fetchDataMutasi(users.id);
    // }
  }, [token]);

  
  const mutasiListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Tanggal',
        id: 'tanggal',
        width: '5%',
        accessor: 'tanggal',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.trxpinjam).format("DD-MM-yyyy")}</div>
      },
      {
        Header: 'Nomor Pinjaman',
        id: 'debit',
        width: '12%',
        accessor: 'debit',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.notrxdetailpinjam}</div>
      },
      {
        Header: 'Cicilan',
        id: 'cicilan',
        width: '12%',
        accessor: 'cicilan',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>Rp.{parseFloat(cellInfo.row.original.cicilan).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Cicilan Ke-',
        id: 'remarks',
        width: '8%',
        accessor: 'remarks',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.cicilan_ke} dari {cellInfo.row.original.lama}</div>
      },
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Mutasi Pinjaman"
                columns={columns}
                data={dataMutasi}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Pinjaman Tunai</Link> /{' '}
                <Link to='/tunai/mutasipinjaman' style={{ color: '#333' }}>Mutasi Pinjaman</Link>
              </li>
            </ol>
          </div>

          {/* Download Report Data */}
          {/* <div className='col-auto ml-auto d-print-none'>
            <Link to="/employee/reportemployee">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('download report data')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Download" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Download Mutasi</span>
                </div>
              </button>
            </Link>
          </div> */}

        </div>
      </div>
    </>
  )

    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : mutasiListView()}

    </div>

  );

}

export default MutasiPinjaman;